// config.js
const BASE_URL = "https://api.shipclues.in/";

export const config = {
  authentication: {
    signIn: `${BASE_URL}api/v1/admin-employee/login/`,
    signUp: `${BASE_URL}api/v1/admins/admin/register/`,
  },

  profile: {
    info: `${BASE_URL}api/v1/admin-employee/profile/`,
  },

  dashboard: {
    count: `${BASE_URL}api/v1/admins/analytics/orders/daily-status-count/`,
    onboarding: `${BASE_URL}api/v1/admins/sellers/user-count/`,
  },

  admin_user: {
    list: `${BASE_URL}api/v1/admins/all/users/profile/`,
    // Legacy permissions (still kept for backward compatibility)
    permissions: (id) =>
      `${BASE_URL}api/v1/admins/views/${id}/permission-matrix/`,
    update: (id) => `${BASE_URL}api/v1/admins/user/profile/${id}/update/`,
    createStats: `${BASE_URL}api/v1/admins/user-register/`,
    createSuper: `${BASE_URL}api/v1/admins/superuser-register/`,
    updatePermissions: (id) =>
      `${BASE_URL}api/v1/admins/update/${id}/permission-sync/`,
    // New UI permissions APIs (GET / PUT) for Admin/Employee UI access
    
    uiPermissions: `${BASE_URL}api/v1/admins/login-user/ui-permissions/`,
    adminEmployeePermissions: `${BASE_URL}api/v1/admin-employee/employee-permissions/`,
    permissionupdate: `${BASE_URL}api/v1/admins/users/ui-permissions/`,
    
  },

  sellers: {
    list: `/admins/sellers-list/`,
    // GET /api/v1/admins/sellers-list/?page_size=100&page=1
    admin_list: `${BASE_URL}api/v1/admins/sellers-list/`,
    admin_list_all: `${BASE_URL}api/v1/admins/sellers-list/all/`,
    admin_list_basic: `${BASE_URL}api/v1/admins/seller-list/basic/`,
    basic_info: `/admins/company-details/`,
    account_info: `/admins/bank-details/`,
    kyc_info: `/admins/kyc-documents/`,
    kyc_document: `/admins/kyc-document/`,
    verify_company: `/admins/verify-company/`,
    verify_bank: `/admins/verify-bank/`,
    verify_account: `/admins/verify-account/`,
    verify_kyc: `/admins/verify-kyc-document/`,
    verify_kyc_document: `/admins/verify-kyc-document/`,
  },
  billing: {
    freight_invoices_export: `${BASE_URL}api/v1/admins/freight-invoices/export/`,
    // SMS Invoice APIs
    sms_invoices_list: `${BASE_URL}api/v1/admins/vas-invoices/sms/list/`,
    sms_export: `${BASE_URL}api/v1/admins/notification-invoices/export/`,
    sms_invoice_download: (invoiceId) => `${BASE_URL}api/v1/admins/notification-invoices/${invoiceId}/download/`,
    // ECOD Invoice APIs
    ecod_invoices_list: `${BASE_URL}api/v1/admins/vas-invoices/ecod/list/`,
    ecod_export: `${BASE_URL}api/v1/admins/early-cod-invoices/export/`,
    ecod_invoice_download: (invoiceId) => `${BASE_URL}api/v1/admins/early-cod-invoices/${invoiceId}/download/`,
  },
  orders: {
    // Updated to use the new order-report export endpoint
    //report: `${BASE_URL}api/v1/admins/order-report/export/`,
    report: `${BASE_URL}api/v1/admins/order-export/request/`,
    bulk_export: `${BASE_URL}api/v1/admins/upload-awb-csv/export/`,
    awb_export: `${BASE_URL}api/v1/admins/export/orders/shipments/`,
  },
  vas: {
    // Legacy endpoints - use billing.sms_invoices_list and billing.ecod_invoices_list instead
    sms_invoices_list: `${BASE_URL}api/v1/admins/vas-invoices/`,
    sms_invoices: `${BASE_URL}api/v1/admins/vas-invoices/`,
    ecod_invoices: `${BASE_URL}api/v1/admins/vas-invoices/`,
  },

  logistics: {
    partner_list: `${BASE_URL}api/v1/admins/partners/`,
    detail: `${BASE_URL}api/v1/admins/partners/`,
    edit: `${BASE_URL}api/v1/admins/partners/`,
  },

  plan: {
    plan_list: `${BASE_URL}api/v1/admins/plans/`,
  },

  early_cod: {
    ecod_list: `${BASE_URL}api/v1/admins/early-cod/`,
    create_ecod: `${BASE_URL}api/v1/admins/early-cod/`,
    update_ecod: `${BASE_URL}api/v1/admins/early-cod/`,
  },

  wallet_history: {
    wallet_list: `${BASE_URL}api/v1/admins/wallet/export/history/`,
  },

  seller_recharge: {
    recharge_list: `${BASE_URL}api/v1/admins/wallet/export/recharges/`,
  },

  // wallet_history: {
  //   wallet_list: `${BASE_URL}api/v1/admins/wallet/export/history/`,
  // },

  manual_wallet: {
    recharge: `${BASE_URL}api/v1/admins/wallet/manual-recharge/`,
    // send_otp: `${BASE_URL}api/v1/admins/wallet/manual-recharge/`,
  },

  finance: {
    SellerShippingRate: `${BASE_URL}api/v1/admins/view/seller-rates/`,
    SellerShippingRateExport: `${BASE_URL}api/v1/admins/view/seller-rates/export/`,
    SellerShippingRateSample: `${BASE_URL}api/v1/admins/download-seller-rate-card-sample/`,
    SellerShippingRateUpload: `${BASE_URL}api/v1/admins/upload-seller-rate-cards/`,
    SellerShippingRateUpdate: `${BASE_URL}api/v1/admins/seller-courier-rate/`,
    export: {
      cod_remittance:
        "https://api.shipclues.in/api/v1/finance/export/cod-remittance/",
    },
  },

  weight_discrepancy: {
    import: `${BASE_URL}api/v1/admins/import-weight-discrepancy/`,
    list: `${BASE_URL}api/v1/admins/weight-discrepancies/`,
    export: `${BASE_URL}api/v1/admins/export-weight-discrepancy/`,
  },

  dispute_records: {
    list: `${BASE_URL}api/v1/admin-employee/dispute-records/`,
    create: `${BASE_URL}api/v1/admin-employee/dispute-records/`,
    detail: (id) => `${BASE_URL}api/v1/admin-employee/dispute-records/${id}/`,
    update: (id) => `${BASE_URL}api/v1/admin-employee/dispute-records/${id}/`,
    action: (id) =>
      `${BASE_URL}api/v1/admin-employee/dispute-records/${id}/action/`,
    remarks: (id) =>
      `${BASE_URL}api/v1/admin-employee/dispute-records/${id}/remarks/`,
    export: `${BASE_URL}api/v1/admin-employee/dispute-records/export/`,
  },
  cod_remittance: {
    list: `${BASE_URL}api/v1/admins/cod-remittance/`,
    mark_paid_import: `${BASE_URL}api/v1/admins/cod-remittance-import/mark-paid/`,
    pending: `${BASE_URL}api/v1/admins/cod-remittance/pending/`,
    pending_export: `${BASE_URL}api/v1/admins/cod-remittance/pending/export/`,
    logs: `${BASE_URL}api/v1/admins/cod-remittance/logs/`,
    logs_error_export: `${BASE_URL}api/v1/admins/cod-remittance/logs/error-export/`,
  },

  employees: {
    list: `${BASE_URL}api/v1/admins/employees/`,
    create: `${BASE_URL}api/v1/admins/employees/create/`,
    update: `${BASE_URL}api/v1/admins/employees/update/`,
  },

  adminEmployees: {
    list: `${BASE_URL}api/v1/admin-employee/employees/`,
    hodList: `${BASE_URL}api/v1/admin-employee/hod-employees/`,
    bulkImport: `${BASE_URL}api/v1/admin-employees/bulk-import/`,
    detail: (id) => `${BASE_URL}api/v1/admin-employee/employees/${id}/`,
    assignSellers: (id) =>
      `${BASE_URL}api/v1/admin-employee/employees/${id}/assign-sellers/`,
    assignedSellers: (id) =>
      `${BASE_URL}api/v1/admin-employee/employees/${id}/sellers/`,
    sellersList: `${BASE_URL}api/v1/admin-employee/sellers-list/`,
    sellers: `${BASE_URL}api/v1/admin-employee/sellers/`,
    sellerLogin: (id) =>
      `${BASE_URL}api/v1/admin-employee/sellers/login/${id}/`,
    journeyTypeCounters: `${BASE_URL}api/v1/admin-employee/journey-type-counters/`,
    orderList: `${BASE_URL}api/v1/admin-employee/order-list/`,
    paidCodCycles: `${BASE_URL}api/v1/admin-employee/paid-cod-cycles/`,
    pendingCodCycles: `${BASE_URL}api/v1/admin-employee/pending-cod-cycles/`,
    shipmentPerformanceMetrics: `${BASE_URL}api/v1/admin-employee/shipment-performance-metrics/`,
    shipmentShippedCreatedMetrics: `${BASE_URL}api/v1/admin-employee/shipment-shipped-created-metrics/`,
    teamPerformanceHodCounters: `${BASE_URL}api/v1/admin-employee/team-performance/hod-counters/`,
    teamPerformanceHodEmployees: `${BASE_URL}api/v1/admin-employee/team-performance/hod-employees/`,
    teamPerformanceHodEmployeeSellers: (id) =>
      `${BASE_URL}api/v1/admin-employee/team-performance/hod-employees/${id}/sellers/`,
    serviceability: `${BASE_URL}api/v1/admin-employee/serviceability/`,
    orderExportRequest: `${BASE_URL}api/v1/admin-employee/order-export/request/`,
    orderExportList: `${BASE_URL}api/v1/admin-employee/order-export/list/`,
    orderExportUploadAwbCsv: `${BASE_URL}api/v1/admin-employee/order-export/upload-awb-csv/`,
    orderExportDownloadUrl: `${BASE_URL}api/v1/admin-employee/order-export/download-url/`,
    orderExportDownload: `${BASE_URL}api/v1/admin-employee/order-export/download/`,
  },

  // Admin Reports - Async Order Export APIs
  admin_reports: {
    list: `${BASE_URL}api/v1/admins/order-export/list/`,
    download: `${BASE_URL}api/v1/admins/order-export/download-url/`,
    downloadDirect: `${BASE_URL}api/v1/admins/order-export/download/`,
  },

  // Technologies APIs
  technologies: {
    serviceability_check: `${BASE_URL}api/v1/admins/serviceability/`,
  },
};

export default config;
